// EmptyResults — Presentational message shown when a search returns no results.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// and text are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';

export const EmptyResults = React.memo(function EmptyResults() {
  return (
    <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
      <p>No restaurants found. Try adjusting your filters.</p>
    </div>
  );
});

export default EmptyResults;
